import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-redirect-page',
  templateUrl: './redirect-page.component.html',
  styleUrls: ['./redirect-page.component.css'],
})
export class RedirectPageComponent {}
